import { Component, Input, ViewEncapsulation } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { CerrixButtonComponent } from "@app/shared/atoms/cerrix-button/cerrix-button.component";

@Component({
    selector: "cerrix-icon-button",
    imports: [CerrixButtonComponent, MatIcon],
    templateUrl: "./cerrix-icon-button.component.html",
    styleUrl: "./cerrix-icon-button.component.scss",
    encapsulation: ViewEncapsulation.None,
})
export class CerrixIconButtonComponent {
    @Input() text: string;
    @Input() icon: string;

    @Input() resultText: string;
    @Input() resultIcon: string;

    @Input() iconPosition: "left" | "right";

    @Input() buttonType: "primary" | "secondary" = "primary";
    @Input() primaryColor: "blue" | "green" | "red" | "yellow" = "blue";
    @Input() secondaryColor: "outlined" | "outlined-gray" | "filled" | "filled-blue" = "outlined";
    @Input() buttonSize: "big" | "medium" | "small" = "medium";
    @Input() public waitingOnResult: boolean = false;
    @Input() public showResultText: boolean = false;
    @Input() disabled: boolean = false;
}
